import { __read } from "tslib";
function convert(text) {
    var textList = text.split("");
    for (var i = 0; i < textList.length; i++) {
        if (textList[i] === "-") {
            textList.splice(i, 1);
            textList[i] = textList[i].toUpperCase();
        }
    }
    var str = textList.join();
    var strHump = str.replace(/,/g, "");
    return strHump;
}
export function parseStyleText(text) {
    if (typeof text === "string") {
        var style_1 = {};
        text
            .split(";")
            .map(function (i) { return i.trim(); })
            .filter(Boolean)
            .forEach(function (pair) {
            var _a = __read(pair.split(":").map(function (i) { return i.trim(); }), 2), key = _a[0], value = _a[1];
            if (key && value) {
                style_1[convert(key)] = value;
            }
        });
        return style_1;
    }
    return text;
}
//# sourceMappingURL=parse-style-text.js.map